import { TextField } from '@fv/client-components'
import {
  type QuoteReasonPayload,
  quoteSelectionReasonLabels,
  type ReasonType,
} from '@fv/models'

import { InputGroup } from '@/components/inputs/InputGroup'

import { orderedOptions } from './constants'

type CompactProps = {
  value: QuoteReasonPayload
  onChange: (payload: QuoteReasonPayload) => void
}
export const CompactQuoteReasonForm = ({ onChange, value }: CompactProps) => {
  return (
    <div>
      <InputGroup
        label="Please choose a reason you have not chosen the cheapest option."
        inputType="select"
        inputProps={{
          options: orderedOptions.map(o => ({
            text: quoteSelectionReasonLabels[o].label,
            value: o,
          })),
          name: 'reasonType',
          value: value.reasonType,
          onChange: e =>
            onChange({ ...value, reasonType: e.target.value as ReasonType }),
        }}
      />
      {value.reasonType === 'other' && (
        <TextField
          placeholder="Enter your reason here (50 characters max)"
          name="description"
          value={value.description}
          onChange={e => onChange({ ...value, description: e.target.value })}
          maxLength={50}
          className="form-control"
        />
      )}
    </div>
  )
}
